import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { 
  searchAddress, 
  selectAddress,
  selectAddressResults, 
  selectAddressLoading, 
  selectAddressError 
} from '../redux/WithcookieSlice';
import { useTranslation } from '../redux/TranslationHelper';
import './AddressSearchPopup.css';

const AddressSearchPopup = ({ onClose }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const dispatch = useDispatch();
  const addressResults = useSelector(selectAddressResults);
  const loading = useSelector(selectAddressLoading);
  const error = useSelector(selectAddressError);
  const { t } = useTranslation();

  // 검색 핸들러
  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      dispatch(searchAddress(searchQuery.trim()));
    }
  };

  // 주소 선택 핸들러
  const handleSelectAddress = (address) => {
    dispatch(selectAddress(address));
    onClose();
  };

  return (
    <div className="address-search-popup-overlay">
      <div className="address-search-popup">
        <div className="address-search-header">
          <h3>{t('주소 검색')}</h3>
          <button 
            type="button" 
            className="close-button" 
            onClick={onClose}
            aria-label={t('닫기')}
          >
            &times;
          </button>
        </div>
        
        <div className="address-search-content">
          <form onSubmit={handleSearch} className="address-search-form">
            <div className="search-input-group">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder={t('도로명 주소, 건물명 또는 지번 입력')}
                className="address-search-input"
              />
              <button type="submit" className="address-search-button">
                {t('검색')}
              </button>
            </div>
            <p className="search-tip">
              {t('예시: 네이버, 강남역, 서초동 137, 테헤란로 152 등')}
            </p>
          </form>
          
          {loading && (
            <div className="address-loading">
              <p>{t('주소를 검색 중입니다...')}</p>
            </div>
          )}
          
          {error && (
            <div className="address-error">
              <p>{typeof error === 'object' ? error.message || JSON.stringify(error) : error}</p>
            </div>
          )}
          
          {!loading && addressResults.length > 0 && (
            <div className="address-results">
              <ul className="address-results-list">
                {addressResults.map((address, index) => (
                  <li 
                    key={index} 
                    className="address-result-item"
                    onClick={() => handleSelectAddress(address)}
                  >
                    <div className="address-info">
                      <p className="address-road">
                        <strong>{t('도로명')}:</strong> {address.road}
                      </p>
                      <p className="address-jibun">
                        <strong>{t('지번')}:</strong> {address.jibun}
                      </p>
                      <p className="address-postal">
                        <strong>{t('우편번호')}:</strong> {address.postalCode}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          )}
          
          {!loading && addressResults.length === 0 && searchQuery && (
            <div className="no-results">
              <p>{t('검색 결과가 없습니다.')}</p>
              <p>{t('검색어를 다시 확인해주세요.')}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddressSearchPopup; 